import { motion } from "framer-motion"
import { useTranslation } from "react-i18next"

export default function About() {
  const { t } = useTranslation()
  return (
    <section
      id="onas"
      className="py-24 bg-white dark:bg-gray-800 px-4 scroll-mt-4 md:scroll-mt-10"
    >
      <motion.h2
        initial={{ y: 20, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true }}
        className="text-3xl font-semibold text-center mb-12 text-primary"
      >
        {t("aboutSection.title")}
      </motion.h2>
      <div className="max-w-4xl mx-auto space-y-8 text-gray-700 dark:text-gray-200">
        <motion.p
          whileInView={{ opacity: 1 }}
          initial={{ opacity: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {t("aboutSection.description")}
        </motion.p>
        {/*
        <motion.div
          id="kariera"
          whileInView={{ opacity: 1 }}
          initial={{ opacity: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="border-l-4 border-primary bg-primary/10 dark:bg-primary/30 p-6 rounded-lg scroll-mt-24 flex flex-col"
        >
          <h3 className="text-2xl font-semibold mb-4 text-primary">
            {t("aboutSection.careerTitle")}
          </h3>
          <span className="whitespace-pre-line">
            {t("aboutSection.careerText")}
          </span>
          <span className="font-bold mt-5">
            {t("aboutSection.careerOptionsTitle")}
          </span>
          <ul className="list-disc list-inside mt-2 space-y-1">
            {t("aboutSection.careerOptions", { returnObjects: true }).map(
              (option) => (
                <li key={option}>{option}</li>
              )
            )}
          </ul>
        </motion.div>
        */}
      </div>
    </section>
  )
}
